import { render, staticRenderFns } from "./DetalleTabs.vue?vue&type=template&id=57041980&"
import script from "./DetalleTabs.vue?vue&type=script&lang=ts&"
export * from "./DetalleTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports